import React from 'react';
import PropTypes from 'prop-types';
import IntroCard from 'common/components/intro-card';
import * as ModalType from 'storyboard/constants/modal-type';
import {t} from 'common/utils/translation-util';
import './index.scss';

export default class StoryboardIntroCard extends React.Component {
  static propTypes = {
    buttonText: PropTypes.string,
    data: PropTypes.object.isRequired,
    enums: PropTypes.object.isRequired,
    message: PropTypes.string,
    openModal: PropTypes.func,
  };

  static defaultProps = {
    buttonText: t('Add a chapter'),
    message: t('Assemble chapters to create a storyboard.'),
    openModal: () => {},
  };

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  getStyle(data, enums) {
    const {theme} = data.configuration;
    const {NavPositionEnum} = enums;
    return theme.navPosition === NavPositionEnum.TOP.id
      ? {
          top: '28%',
        }
      : {
          top: '18%',
        };
  }

  render() {
    const style = this.getStyle(this.props.data, this.props.enums);
    return (
      <div className={'StoryboardIntroCard'} style={style}>
        <IntroCard
          buttonText={this.props.buttonText}
          onButtonClick={this.handleClick}
          style={{
            pointerEvents: 'all',
          }}>
          <div
            style={{
              backgroundImage: 'url(/static/www/icons/storyboards-zero.svg)',
            }}
          />
          <h4>{t('Get Started')}</h4>
          <p>
            {t(
              'Combine dashboards and media to create a data-driven story for public display.',
            )}
          </p>
        </IntroCard>
      </div>
    );
  }

  handleClick(event) {
    event.preventDefault();
    this.props.openModal(ModalType.ADD_CHAPTER, this.props.buttonText);
  }
}
